/**
 A dataholder object for all the parameters to the ListPageLogic object.
 Use this to override the defaults.  For example:

 let lplp = new ListPageLogicParams();
 lplp.deletePrompt = "Delete these locks?";

 @param insideChildIframe pass true for old iframe based pages
 */
export function ListPageLogicParams(insideChildIframe) {
    this.chkAllElm = document.getElementById("chkAll");

    this.chkTblElm = document.getElementById("listTable");

    // if using <csp:listingTable>
    if (this.chkTblElm == null)
        this.chkTblElm = document.getElementById("listing-table");

    this.chkTblRowOnClassName = "rowOn";
    this.chkTblRowOffClassName = "rowOff";

    this.chkTblRowIDPrefix = "clickable-row-";
    this.chkTblRowChkIDPrefix = "clickable-row-cb-";

    this.deletePrompt = i18n.common.deleteConfirm;
    this.movePrompt = null; // by default don't prompt on move
    this.hidePrompt = null; // by default don't prompt on hide

    // this.flashElm = document.getElementById("spanNumSel");
    this.flashOffClassName = "flashOff";
    this.flashOnClassName = "flashOn";

    this.totalCountElm = document.getElementById("spanNumTotal");
    this.selectedCountElm = document.getElementById("spanNumSel");
    this.itemsCopiedElm = document.querySelector('.items-copied-label');

    this.FrmItemDelete = document.FrmItemDelete;
    this.FrmItemHide = document.FrmItemHide;
    this.FrmItemCopy = document.FrmItemCopy;
    this.FrmItemMove = document.FrmItemMove;
    this.FrmList = document.FrmList;
    this.PageForm = document.PageForm;

    this.deleteAction = 'DeleteCtrl.act';
    this.hideAction = 'HideCtrl.act';
    this.pasteAction = 'PasteCtrl.act';
}